import { FC } from 'react';
import Box from '@mui/material/Box';

export interface ProgressBarProps {
  /** 0..1. Values outside the range are clamped. */
  value: number;
  label: string;
  'data-testid'?: string;
}

/**
 * The 6 px tray progress bar (DD-031). `role="progressbar"` with an accessible
 * value so a screen reader gets the fraction the bar draws.
 */
export const ProgressBar: FC<ProgressBarProps> = ({
  value,
  label,
  'data-testid': testId = 'run-progress-bar',
}) => {
  const clamped = Math.max(0, Math.min(1, Number.isFinite(value) ? value : 0));

  return (
    <Box
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(clamped * 100)}
      data-testid={testId}
      sx={{
        width: '100%',
        height: 6,
        borderRadius: 3,
        backgroundColor: 'grey.300',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          width: `${clamped * 100}%`,
          height: '100%',
          backgroundColor: 'primary.main',
          transition: 'width 240ms ease',
        }}
      />
    </Box>
  );
};

export default ProgressBar;
